import { Box, Container, VStack, useColorModeValue } from "@chakra-ui/react";
import { useIncludedServicesPage } from "./hooks/useIncludedServicesPage";
import { IncludedServicesPageHeader } from "./components/IncludedServicesPageHeader";
import {
  IncludedServicesEmptyState,
  IncludedServicesErrorState,
  IncludedServicesLoadingState,
  IncludedServicesNoResultsState,
} from "./components/IncludedServicesPageStates";
import { ContractWithServices } from "./components/ContractWithServices";

const IncludedServicesPage = () => {
  const {
    error,
    filteredContracts,
    isLoading,
    searchTerm,
    setSearchTerm,
    stats,
    texts,
  } = useIncludedServicesPage();

  const bgGradient = useColorModeValue(
    "linear(to-b, gray.50, white)",
    "linear(to-b, gray.900, gray.800)",
  );

  if (isLoading) {
    return (
      <IncludedServicesLoadingState
        bgGradient={bgGradient}
        loadingText={texts?.includedServicesPage?.loading}
      />
    );
  }

  if (error) {
    return (
      <IncludedServicesErrorState
        bgGradient={bgGradient}
        title={texts?.error}
        error={error}
      />
    );
  }

  return (
    <Box
      height="calc(100dvh - 3rem)"
      overflowY={"auto"}
      bgGradient={bgGradient}
    >
        <IncludedServicesPageHeader
          searchTerm={searchTerm}
          stats={stats}
          texts={texts}
          onSearchChange={setSearchTerm}
        />

        <VStack spacing={1} align="stretch">
          {filteredContracts.length > 0 ? (
            filteredContracts.map((contract) => (
              <ContractWithServices
                key={contract.ContractId}
                contract={contract}
                texts={{
                  mainPackage: texts?.includedServicesPage?.mainPackage,
                  mainPackageDescription:
                    texts?.includedServicesPage?.mainPackageDescription,
                  subPackages: texts?.includedServicesPage?.subPackages,
                  histories: texts?.includedServicesPage?.histories,
                  hasMainPackage: texts?.includedServicesPage?.hasMainPackage,
                  contractId: texts?.includedServicesPage?.contractId,
                  status: texts?.includedServicesPage?.status,
                  endDate: texts?.includedServicesPage?.endDate,
                  expired: texts?.includedServicesPage?.expired,
                  completed: texts?.includedServicesPage?.completed,
                  pending: texts?.includedServicesPage?.pending,
                  loadingServices: texts?.includedServicesPage?.loadingServices,
                  loadingHistories:
                    texts?.includedServicesPage?.loadingHistories,
                  fetchError: texts?.includedServicesPage?.fetchError,
                  noServicesData: texts?.includedServicesPage?.noServicesData,
                  unnamedService: texts?.includedServicesPage?.unnamedService,
                  unnamedContract: texts?.includedServicesPage?.unnamedContract,
                  statistics: texts?.includedServicesPage?.statistics,
                }}
              />
            ))
          ) : searchTerm ? (
            <IncludedServicesNoResultsState
              searchTerm={searchTerm}
              title={texts?.noResults}
              description={texts?.noResultsDesc}
            />
          ) : (
            <IncludedServicesEmptyState
              title={texts?.includedServicesPage?.noContracts}
              description={texts?.includedServicesPage?.noContractsDesc}
            />
          )}
        </VStack>
    </Box>
  );
};

export default IncludedServicesPage;
